export function converteImagemTransparente(ev, img) {
    
}

export function loadImage(idElementErro, idElementImg, idElementPreview) {
    const reader = new FileReader();
    const arquivo = document.getElementById(idElementImg);    
    
    reader.onload = function (e) {        
        var img = new Image();

        img.src = e.target.result;            

        img.onload = function() {   
            var file = arquivo.files[0];                                          

            var el = document.getElementById(idElementErro);      
                        
            el.value = '';

            if(file.type !== 'image/png') el.value = "A imagem não está no formato png";
            else if((img.width !== 512)||(img.height !== 512)) el.value = "O tamanho da imagem não é 512x512";
            
            // var canvas = document.createElement('CANVAS');

            // canvas.width = 512;
            // canvas.height = 512;            
            
            // var context = canvas.getContext('2d');

            // try { 
            //     context.imageSmoothingEnabled = false; 
            // } catch(e) { 
            //     context.msImageSmoothingEnabled = false; 
            // }            

            // context.drawImage(img, 0, 0, canvas.width, canvas.height);

            // var imgData = context.getImageData(0, 0, canvas.width, canvas.height);
            
            // for(var i = 0; i < imgData.data.length; i += 4 ) {
            //     imgData.data[i]   = 1.2*imgData.data[i] + 0*imgData.data[i+1] + 0*imgData.data[i+2] + 0*imgData.data[i+3] + -0.2
            //     imgData.data[i+1] = 0*imgData.data[i] + 1.2*imgData.data[i+1] + 0*imgData.data[i+2] + 0*imgData.data[i+3] + -0.2
            //     imgData.data[i+2] = 0*imgData.data[i] + 0*imgData.data[i+1] + 1.2*imgData.data[i+2] + 0*imgData.data[i+3] + -0.2
            // }
            
            // // cor branca #FFFFFF (R=255, G=255, B=255) => transparente (Alfa=0)
            // // for(var i = 0; i < imgData.data.length; i += 4 ) {                                
            // //     if ( imgData.data[i] === 255 && imgData.data[i+1] === 255 && imgData.data[i+2] === 255 )                
            // //         imgData.data[i+3] = 0;                                
            // // }

            // context.putImageData(imgData, 0, 0)
            
            //document.getElementById(idElementPreview).src = canvas.toDataURL();            
            
            document.getElementById(idElementPreview).src = e.target.result;
        }            
    };

    reader.readAsDataURL(arquivo.files[0]);
}